//import firebase from 'firebase';
import firebase from 'firebase/app';
import 'firebase/firestore';


// Initialize Firebase
var config = {
  apiKey: "AIzaSyAd-rPxCkQhTuDEfyWYaNk-i2uDE4ssNBE",
  authDomain: "feed-d6dfa.firebaseapp.com",
  databaseURL: "https://feed-d6dfa.firebaseio.com",
  projectId: "feed-d6dfa",
  storageBucket: "feed-d6dfa.appspot.com",
  messagingSenderId: "712620479174",
};
firebase.initializeApp(config);
export default firebase;

export const firestore = firebase.firestore();
const settings = {timestampsInSnapshots: true};
firestore.settings(settings);


//export const auth = firebase.auth();
//export const database = firebase.database();
// export const firestore = firebase.firestore();
// export const googleAuthProvider = new firebase.auth.GoogleAuthProvider();




// WEBPACK FOOTER //
// ./state/firebase.js